import { ExportJobDocumentationChanges, PublishedDocEnvironment } from "@supernova-studio/model";
import { z } from "zod";
import { DTOExportJob } from "../export";

export const DTOPublishDocumentationChanges = ExportJobDocumentationChanges;

export const DTOPublishDocumentationRequest = z.object({
  environment: PublishedDocEnvironment,

  /**
   * If defined, this allows narrowing down what is published to a set of specific pages and groups
   * If undefined, everything will be published.
   */
  changes: DTOPublishDocumentationChanges.optional(),
});

export const DTOPublishDocumentationResponse = z.object({
  job: DTOExportJob,
});

export type DTOPublishDocumentationChanges = z.infer<typeof DTOPublishDocumentationChanges>;
export type DTOPublishDocumentationRequest = z.infer<typeof DTOPublishDocumentationRequest>;
export type DTOPublishDocumentationResponse = z.infer<typeof DTOPublishDocumentationResponse>;
